import React, { useMemo, useState } from "react";
import { translate } from "../Services/translation";
import { StockStatus } from "../constants";
import Dialog from "./Dialog";

const removeColonAndNumber = (status) => {
  const regex = /:([0-9]+)$/;

  const match = status.match(regex);

  let resultString;
  if (match) {
    resultString = status.replace(regex, '');
  } else {
    resultString = status;
  }

  return resultString;
}

export const stockTone = (status) => {
  switch (removeColonAndNumber(status || "")) {
    case StockStatus.Green:
    case StockStatus.Yellow:
      return "ok";
    case StockStatus.RedMax:
    case StockStatus.RedHighest:
      return "out";
    default:
      return "order";
  }
};

const ProductStockStatus = ({ status, statusText, storeStatus, isDropshipping, dropshippingInfoHtml, originalDeliveryText, originalDeliveryStatus }) => {

  const formattedStatus = useMemo(() => removeColonAndNumber(status), [status]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const tone = stockTone(status);
  const title = translate(isDropshipping ? "stockstatus.stock-title-dropship" : "stockstatus.stock-title-" + formattedStatus.toLowerCase());
  const subtitle = useMemo(() => {
    const text = (statusText || "").trim();
    if (!text || title.toLowerCase().includes(text.toLowerCase())) {
      return "";
    }
    return text.toLowerCase().startsWith(title.toLowerCase())
      ? text.slice(title.length).replace(/^[\s:–—-]+/, "")
      : text;
  }, [title, statusText]);

  return (
    <>
      <div className={`product-stock-status__row product-stock-status__row--${tone}`}>
        <span className="product-stock-status__dot" aria-hidden="true" />
        <span className="product-stock-status__text">
          {title}
          {subtitle && <> — {subtitle}</>}
          {(isDropshipping && dropshippingInfoHtml) && (
            <button
              className="product-stock-status__read-more"
              onClick={() => setDialogOpen(true)}
            >
              {translate("stockstatus.dropship-readmore")}
            </button>
          )}
        </span>
        {dropshippingInfoHtml && (
          <Dialog
            isOpen={dialogOpen}
            onClose={() => setDialogOpen(false)}
            headerContent={<></>}
            closeButtonAriaLabel={translate("stockstatus.dropship-dialog-header")}
          >
            <div dangerouslySetInnerHTML={{ __html: dropshippingInfoHtml }} />
            {originalDeliveryText && (
              <div className="product-stock-status__original-delivery">
                <h4>{translate("stockstatus.original-delivery-title")}</h4>
                <div className="product-stock-status__original-delivery-text">
                  <p>{originalDeliveryText}</p>
                </div>
              </div>
            )}
          </Dialog>
        )}
      </div>
      {storeStatus !== "False" && (
        <div className="product-stock-status__row product-stock-status__row--ok">
          <span className="product-stock-status__dot" aria-hidden="true" />
          <span className="product-stock-status__text">
            {translate("stockstatus.in-store")}
          </span>
        </div>
      )}
    </>
  );
};

export default ProductStockStatus;
